export default __webpack_public_path__ + "static/media/signal_2.9e8ebf5f.mp3";